import AuthenticationFormsWrapper from './AuthenticationFormsWrapper';

export default AuthenticationFormsWrapper;
